webpackJsonp([72],{

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1340);


/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(777);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1339]);


// WEBPACK FOOTER //
// app/datetime.pt-b752e5bdb90cff611e7d.js